import { createApp } from 'vue';
import App from './App.vue';
import { router } from './router';
import './assets/main.css';
import { installGlobalErrorHandler } from './error-overlay';

const app = createApp(App);
installGlobalErrorHandler(app);
app.use(router).mount('#app');
